export default "__VITE_ASSET__D5lK4Wmu__"